<section class="team">
  <div class="component-content">
    <h3 class="team__title">
    </h3>
    <app-team-members-list></app-team-members-list>
  </div>
</section>